import { WizardDialogComponent } from "./wizard-dialog.component";

export namespace AbstractWizardStepComponent {
	// Angular changed how they do injectors
	// export type ConstructorFunction = new (...args: injectable[]) => AbstractWizardStepComponent;
	// https://blog.angularindepth.com/angular-introduces-staticinjector-should-you-care-4e059eca030c
	export type ConstructorFunction<T> = new (...args: any[]) => AbstractWizardStepComponent<T>;
}

export abstract class AbstractWizardStepComponent<T> {
	private _data: T | undefined;

	public wizard!: WizardDialogComponent<T>;

	// You can not use data on a void defined component
	// if you do, it is undefined and throws the error
	public get data(): T {
		if (!this._data) {
			throw new Error("You are attempting to use data when it should not be used!");
		}
		return this._data;
	}

	public set data(value: T) {
		this._data = value;
	}

	public abstract get title(): string;
	public abstract get description(): string;

	public abstract get nextStep(): AbstractWizardStepComponent.ConstructorFunction<T> | undefined;
	public abstract get previousStep(): AbstractWizardStepComponent.ConstructorFunction<T> | undefined;

	public abstract get isFormValid(): boolean;
	public abstract get showProgressBar(): boolean;

	public abstract performNext(): void | Promise<void>;
	public abstract performPrevious(): void | Promise<void>;
}
